export default class {
  constructor(element) {
    this.element = element;
    this.reviews = element.querySelectorAll(".why-reviews__item");
    this.container = element.querySelector(".why-reviews__list");
    this.prevButton = element.querySelector(".why-reviews__scroll-up");
    this.nextButton = element.querySelector(".why-reviews__scroll-down");
    this.lastIndex = this.reviews.length - 1;

    this.setupEventListeners();
  }

  /*--< ОСНОВНАЯ ЛОГИКА >------------------------------------*/

  scrollTo(index) {
    if (index < 0 || index > this.lastIndex) return;

    const containerRect = this.container.getBoundingClientRect();
    const reviewRect = this.reviews[index].getBoundingClientRect();

    const scrollOptions = this.calculateScrollPosition(
      containerRect,
      reviewRect,
    );

    this.container.scrollTo({
      ...scrollOptions,
      behavior: "smooth",
    });
  }

  topIsVisible(review) {
    const reviewRect = review.getBoundingClientRect();
    const containerRect = this.container.getBoundingClientRect();

    return containerRect.bottom >= reviewRect.top &&
      reviewRect.top >= containerRect.top;
  }

  bottomIsVisible(review) {
    const reviewRect = review.getBoundingClientRect();
    const containerRect = this.container.getBoundingClientRect();

    return containerRect.bottom >= reviewRect.bottom &&
      reviewRect.bottom >= containerRect.top;
  }

  calculateScrollPosition(containerRect, reviewRect) {
    const relativeTop = reviewRect.top - containerRect.top + this.container.scrollTop;

    return {
      top: relativeTop - 1
    };
  }

  /*--< НАВИГАЦИЯ >------------------------------------------*/

  goToPrev() {
    for (let i = 1; i <= this.lastIndex; i++) {
      if (this.topIsVisible(this.reviews[i])) {
        this.scrollTo(i - 1);
        break;
      }
    }
  }

  goToNext() {
    for (let i = this.lastIndex - 1; i >= 0; i--) {
      if (this.bottomIsVisible(this.reviews[i])) {
        this.scrollTo(i + 1);
        break;
      }
    }
  }

  /*--< ОБРАБОТЧИКИ СОБЫТИЙ >--------------------------------*/

  setupEventListeners() {
    this.prevButton.addEventListener("click", () => this.goToPrev());
    this.nextButton.addEventListener("click", () => this.goToNext());
  }
}
